import Locked from '@/svgs/locked.svg?react';
import UnLocked from '@/svgs/unlocked.svg?react';
import { cn } from '@/utils';
import { Tooltip } from '@analytical-alley/ui';
import { Control, Controller } from 'react-hook-form';
import { BudgetRowValues } from './ModifyBudgetRow';

interface Props {
    name: string;
    control: Control<BudgetRowValues>;
    isLocked: boolean;
    disabled: boolean;
    onUnlock: () => void;
    onLock: () => void;
}

const LOCKED_TOOLTIP =
    'Budget is locked to your specified value. The optimizer will not change it.';
const UNLOCKED_TOOLTIP =
    'Budget is unlocked. The optimizer can freely adjust this value based on other constraints.';

export const LockToggle = ({
    name,
    control,
    isLocked,
    disabled,
    onUnlock,
    onLock,
}: Props) => {
    return (
        <Controller
            control={control}
            name="locked"
            render={({ field: { onChange, value } }) => (
                <Tooltip placement="top">
                    <Tooltip.Trigger asChild>
                        <button
                            type="button"
                            id={`input-id-${name}`}
                            disabled={disabled}
                            className={cn('self-center cursor-pointer', {
                                'opacity-50 cursor-not-allowed': disabled,
                            })}
                            onClick={() => {
                                const next = !value;
                                onChange(next);
                                if (!next) {
                                    onUnlock();
                                } else {
                                    onLock();
                                }
                            }}
                        >
                            {isLocked || disabled ? <Locked /> : <UnLocked />}
                        </button>
                    </Tooltip.Trigger>
                    <Tooltip.Content className="tooltip-content">
                        {isLocked || disabled ? LOCKED_TOOLTIP : UNLOCKED_TOOLTIP}
                    </Tooltip.Content>
                </Tooltip>
            )}
        />
    );
};
